/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Button, Table, Form, Modal } from "react-bootstrap";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";

import SupplierTypeService from "../../../core/service/SupplierTypeService";

const SupplierTypeModal = ({ t, isModal, item, callbackModal }) => {
  const [show, setShow] = useState(isModal ? true : false);
  const [editid, setEditId] = useState(item ? item.id : "");
  const [editnamevalue, setEditNamevalue] = useState(item ? item.name : "");
  const [editstatusvalue, setEditStatusvalue] = useState(
    item ? item.active : true
  );
  var data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;

  const handleClose = () => {
    setShow(false);
    setEditId(null);
    setEditNamevalue(null);
    setEditStatusvalue(true);
    callbackModal(false);
  };

  const handleSubmit = async (e) => {
    setShow(false);
    var body = {
      name: editnamevalue,
      active: editstatusvalue,
    };
    if (editid) {
      body["id"] = editid;
    }

    SupplierTypeService.onSubmit(company, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setEditId("");
          setEditNamevalue("");
          setEditStatusvalue(true);
          callbackModal(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          < Modal.Title as="h5">
            Add new suplplier type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("SupplierType.label")}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editnamevalue}
                    placeholder={t("Enternewsuppliertype.label")}
                    required
                    onChange={(e) => setEditNamevalue(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Status.label")}</label>
                  <select
                    className="form-select"
                    value={editstatusvalue}
                    onChange={(e) => setEditStatusvalue(e.target.value)}
                  >
                    <option value={true}>{t("Active.label")}</option>
                    <option value={false}>{t("Inactive.label")}</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
            {t("Create.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withTranslation()(SupplierTypeModal);
